import { useRef, useState } from "react";
import EditPopover from "./EditPopover";
import { formatDisplayValue, getEditableCellConfig } from "./simulatorUtils";

// Composant bouton d'édition avec popover
const EditableCell = ({
  field,
  value,
  className = "",
  disabled = false,
  style = {},
  updateCell,
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const buttonRef = useRef(null);
  const fieldConfig = getEditableCellConfig(field);

  const handleSave = (newValue) => {
    updateCell(field, newValue);
    setIsPopoverOpen(false);
  };

  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        className={`btn btn-link p-0 text-start ${
          !disabled ? "text-orange" : ""
        } ${className}`}
        style={{
          border: "none",
          background: "transparent",
          textDecoration: "none",
          color: "inherit",
          textTransform: "capitalize",
          cursor: disabled ? "not-allowed" : "pointer",
          ...style,
        }}
        onClick={!disabled ? () => setIsPopoverOpen(true) : null}
        onMouseEnter={
          !disabled
            ? (e) => {
                e.target.style.textDecoration = "underline";
                e.target.style.color = "#0d6efd";
              }
            : null
        }
        onMouseLeave={
          !disabled
            ? (e) => {
                e.target.style.textDecoration = "none";
                e.target.style.color = "inherit";
              }
            : null
        }
      >
        {formatDisplayValue(field, value, true)}
      </button>

      <EditPopover
        isOpen={isPopoverOpen}
        onClose={() => setIsPopoverOpen(false)}
        onSave={handleSave}
        field={field}
        fieldLabel={fieldConfig.label}
        fieldType={fieldConfig.type}
        fieldOptions={fieldConfig.options}
        fieldProps={fieldConfig.props}
        currentValue={value}
        buttonRef={buttonRef}
      />
    </>
  );
};

export default EditableCell;
